import React from "react";
import {
    Button,
    DefaultComponentProps,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FlexGrid,
    Link,
    Typography,


} from '@albo-ui/core';
import { TextField } from "@mui/material";
import { ItemType } from "../../../util/hooks/useCatalog";
import { FilterLeadType } from "../../customwidgets/leads-tracking-report/types";
import { useFilterLead } from "./hooks/useFiltersLead";







export type FiltersLeadDialogProps = {
    onConfirm: (selectedFilters: FilterLeadType) => void;
    onClose: () => void;
    open: boolean;
    status: ItemType[];
    selectedFilters: FilterLeadType,
    isDownload: boolean
} & DefaultComponentProps;


const itemsLeadTypes = [
    { name: "PM", value: "PM" },
    { name: "PFAE", value: "PFAE" },
    { name: "Todos los tipos", value: "todos" },
]

const itemsResponsibles = [
    { name: "Cliente", value: "Cliente" },
    { name: "Operaciones", value: "Operaciones" },
    { name: "Todos los responsables", value: "todos" },
]


export const FiltersLeadDialog = ({
    onConfirm,
    onClose,
    open,
    className,
    style,
    selectedFilters,
    status,
    isDownload
}: FiltersLeadDialogProps) => {

    const { filter, onSelectStatus, statusSelected, handleBorrarFiltros, fechaInicio, setFechaInicio, leadType, setLeadType, leadResponsible, setLeadResponsible, fechaFin, setFechaFin, isValidFilters } = useFilterLead(selectedFilters, onConfirm, open, status, isDownload)

    return (
        <Dialog className={className} style={style} onClose={onClose} open={open}>
            <DialogTitle>
                <Typography variant="h2"> Filtrar por</Typography>
            </DialogTitle>
            <DialogContent>
                <FlexGrid container
                    fullHeight
                    fullWidth
                    direction="column"
                    justify='space-between'
                    alignItems='flex-start'
                    spacing={2}>

                    <FlexGrid fullWidth
                        direction="row"
                        justify='space-between'
                        alignItems='space-between'
                        container
                        spacing={2}
                    >
                        <TextField
                            name="fechaInicio"
                            type="date"
                            placeholder="Fecha inicio"
                            label="Fecha inicio"
                            variant="outlined"
                            color="secondary"
                            InputLabelProps={{ shrink: true }}
                            style={{ flex: 1 }}
                            value={fechaInicio}
                            error={!isValidFilters}
                            onChange={(e) => setFechaInicio(e.target.value)}


                        />
                        <TextField
                            name="fechaFin"
                            type="date"
                            placeholder="Fecha fin"
                            label="Fecha fin"
                            variant="outlined"
                            color="secondary"
                            error={!isValidFilters}
                            InputLabelProps={{ shrink: true }}
                            style={{ flex: 1 }}
                            value={fechaFin}
                            onChange={(e) => setFechaFin(e.target.value)}
                        />

                    </FlexGrid>

                    <select
                        placeholder="Tipo"
                        className="select"
                        defaultValue={leadType}
                        onChange={(e) => { setLeadType(e.target.value) }}
                    >
                        {itemsLeadTypes.map(i => <option key={i.value} value={i.value}>{i.name}</option>)}
                    </select>

                    <select
                        placeholder="Responsable"
                        className="select"
                        defaultValue={leadResponsible}
                        onChange={(e) => { setLeadResponsible(e.target.value) }}
                    >
                        {itemsResponsibles.map(i => <option key={i.value} value={i.value}>{i.name}</option>)}
                    </select>



                    <Typography variant='smallTitle'>Estatus </Typography>
                    <FlexGrid container
                        fullHeight
                        fullWidth
                        direction="column"
                        justify='space-between'
                        alignItems='flex-start'
                        spacing={1}>
                        {status.map(s => {
                            return <FlexGrid fullWidth
                                direction="row"
                                justify='flex-start'
                                alignItems='center'
                                container
                                spacing={2}
                                key={s.value}
                            >
                                <label htmlFor={"chk-" + s.value}>
                                    <input type="checkbox" id={"chk-" + s.value} value={s.name}
                                        checked={statusSelected[s.name]}
                                        onChange={onSelectStatus} />
                                    {s.metadata?.description}
                                </label>
                            </FlexGrid>
                        })}
                    </FlexGrid>

                    <Link underlined bold onClick={handleBorrarFiltros}>Borrar filtros </Link>

                </FlexGrid>

            </DialogContent>
            <DialogActions>
                <FlexGrid
                    container
                    fullHeight
                    fullWidth
                    justify='space-between'
                    alignItems='flex-end'
                    style={{ marginTop: '20px' }}
                >
                    <FlexGrid item>
                        <Button onClick={onClose} buttonType='secondary' size='normal'>
                            Cancelar
                        </Button>
                    </FlexGrid>
                    <FlexGrid item>
                        <Button onClick={filter} size='normal' disabled={!isValidFilters}>
                            Filtrar
                        </Button>
                    </FlexGrid>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    );
};
